import { useMemo } from "react"
import { mainMenu } from './menu';

interface Props {
    pendingChatCount: number
}
const usePrimaryMenu = ({ pendingChatCount }:Props ) => {
    const primaryMenu = useMemo(() => {
        return mainMenu.map(menu => {
            if(menu.name === 'Chat') {
                return {
                    ...menu,
                    count: pendingChatCount
                }
            }

            return menu;
        })
    },[pendingChatCount]);

    return primaryMenu;
}

export default usePrimaryMenu;
